import ToastCustom from 'src/javascripts/components/alerts/ToastCustom';
import {filterTypeaheadNoCache} from 'src/javascripts/components/typeaheads/TypeaheadBloodhounds';
import ToggleNewData from './ToggleNewData';

// Registries store WeakRef<Bloodhound> instances to avoid retaining unused Bloodhound objects.
const documentBloodhoundRegistry = [];
const linkBloodhoundRegistry = [];
let hasBoundDocumentListener = false;

function addBloodhoundInstance(registry, instance) {
  if (!instance) { return; }

  // Avoid adding duplicates: check if any live WeakRef already points to this instance.
  for (let i = registry.length - 1; i >= 0; i -= 1) {
    const existingRef = registry[i];
    const existingInstance = existingRef && typeof existingRef.deref === 'function'
      ? existingRef.deref()
      : null;

    if (!existingInstance) {
      // Clean up dead WeakRefs.
      registry.splice(i, 1);
      continue;
    }

    if (existingInstance === instance) {
      return;
    }
  }

  // Store a weak reference so the Bloodhound instance can be garbage-collected when unused.
  if (typeof WeakRef !== 'undefined') {
    registry.push(new WeakRef(instance));
  } else {
    // Fallback for environments without WeakRef: store a strong reference (previous behavior).
    registry.push(instance);
  }
}

function addRecordToRegistry(registry, record) {
  for (let i = registry.length - 1; i >= 0; i -= 1) {
    const entry = registry[i];
    let bloodhoundInstance = entry;

    // Handle WeakRef entries if supported.
    if (entry && typeof entry.deref === 'function') {
      bloodhoundInstance = entry.deref();
      if (!bloodhoundInstance) {
        // The target has been garbage-collected; remove this entry from the registry.
        registry.splice(i, 1);
        continue;
      }
    }

    if (bloodhoundInstance && typeof bloodhoundInstance.add === 'function') {
      bloodhoundInstance.add([record]);
    }
  }
}

// Keep the client-side Bloodhound caches in sync when new documents are uploaded via AJAX
function registerNewDocumentListener() {
  if (hasBoundDocumentListener) { return; }
  hasBoundDocumentListener = true;
  $(document).on('survey:documents:newDocument', (_event, payload = {}) => {
    const { record, document_type: documentType } = payload;
    if (!record) { return; }
    if (documentType === 'link') {
      addRecordToRegistry(linkBloodhoundRegistry, record);
    } else {
      addRecordToRegistry(documentBloodhoundRegistry, record);
    }
  });
}

export default function(parentContainerEl, parentContainer) {
  let accountUrl = $('body').attr('data-account-url');
  let surveySlug = $('.polling-indicator').attr('data-slug');
  let answerId = parentContainer.find('.documents-typeahead').attr('data-answer-id');
  let searchUrl = "/" + accountUrl + "/surveys/" + surveySlug + "/documents?"
  const documentsBloodhound = filterTypeaheadNoCache(parentContainerEl + ' .documents-typeahead', 'documents', searchUrl + 'type=document&display_col=name_no_link', 143, 'generic');
  const linksBloodhound = filterTypeaheadNoCache(parentContainerEl + ' .links-typeahead', 'links', searchUrl + 'type=link&display_col=name_no_link', 143, 'generic');
  addBloodhoundInstance(documentBloodhoundRegistry, documentsBloodhound);
  addBloodhoundInstance(linkBloodhoundRegistry, linksBloodhound);
  registerNewDocumentListener();

  // Track whether current input value was selected from typeahead suggestions.
  parentContainer.find('.documents-typeahead, .links-typeahead').on('input', function() {
    $(this).data('typeahead-has-selection', false);
  });

  parentContainer.find('.links-typeahead').on('blur', function() {
    let el = $(this);
    let typedValue = (el.val() || '').trim();
    let hasSelection = el.data('typeahead-has-selection') === true;

    if (typedValue.length > 0 && !hasSelection) {
      ToastCustom({
        title: 'No matching link found',
        message: 'No existing link matched. Use "Paste a link to use as a source..." below to add a new link.',
        type: 'information'
      });
    }
  });

  parentContainer.find('.documents-typeahead, .links-typeahead').bind('typeahead:beforeselect typeahead:autocomplete', function(ev, suggestion) {
    let answerId = $(this).attr('data-answer-id');
    let documentId = suggestion.record_id;
    ev.preventDefault();
    $(this).data('typeahead-has-selection', true);

    // Only continue if not already added
    let exists = $(this).closest('.action-container').find('.document-row[data-document-id=\'' + documentId + '\']');
    if (exists.length !== 0) {
      ToastCustom({title: 'Already attached', message: 'You have already attached that document to this response'});

      // Blur input 
      $(this).blur();

    } else {

      // Blur input 
      $(this).blur();

      // Set card body to indicate value changed for reloading page
      let cardBody = $(this).closest('.card-body.survey-card-body');
      cardBody.attr('data-val-changed', 'true');
      ToggleNewData($(this));

      // Upload file
      let url = "/" + accountUrl + '/surveys/' + surveySlug + '/answer_documents';
      let formData = {}
      formData['answer_id'] = answerId;
      formData['document_id'] = documentId;

      // Update documents or links count indicator, whichever is relevant
      let isLink = suggestion.document_type === 'link';
      let countSpanClass = isLink ? '.uploaded-links-count' : '.uploaded-documents-count';
      let documentsCountSpan = $(this).closest('.question-row').find(countSpanClass);
      if (documentsCountSpan.length !== 0) {
        let currentCount = parseInt(documentsCountSpan.text().replace('(', '').replace(')', '')) || 0;
        documentsCountSpan.text('(' + (currentCount + 1) + ')');
        documentsCountSpan.removeClass('d-none');
      }
      
      // Update local attribute
      return $.ajax({
        type: 'POST',
        url: url,
        dataType: "script",
        data: formData
      });
    }
  });


}
